'use client';

import { Fragment } from 'react';

import { stateAbbreviationTitles } from '@/constants/states';

import { PropsWithClasses } from '@lamesarv-sdk/types';
import { IDynamicsOptionSet } from '@/types/dynamicsForms';

import { CommonSelect } from './CommonSelect';

interface ICommonLocationSelectProps extends PropsWithClasses {
  locationsOptionSet: IDynamicsOptionSet;
  name?: string;
  label?: string;
  hideLabel?: boolean;
  usePlaceholder?: boolean;
  isRequired?: boolean;
  placeholder?: string;
  classContainer?: string;
  classLabel?: string;
  classLabelWithValue?: string;
  classInputWithValue?: string;
}

export const CommonLocationSelect = (props: ICommonLocationSelectProps) => {
  if (!props.locationsOptionSet) return null;

  const stateLocations = props.locationsOptionSet.reduce(
    (acc, option) => {
      const [city, stateAbbreviation] = option.Label.split(',').map((part) => part.trim());
      if (!stateAbbreviation || !stateAbbreviationTitles[stateAbbreviation]) return acc;
      if (!acc[stateAbbreviation]) acc[stateAbbreviation] = [];
      acc[stateAbbreviation].push({ city, fullLocation: option.Label });
      return acc;
    },
    {} as Record<
      string,
      {
        city: string;
        fullLocation: string;
      }[]
    >,
  );

  const getCustomOptions = () => {
    return (
      <Fragment>
        {Object.entries(stateLocations)
          .sort(([stateAbbreviationA], [stateAbbreviationB]) =>
            stateAbbreviationTitles[stateAbbreviationA].localeCompare(stateAbbreviationTitles[stateAbbreviationB]),
          )
          .map(([stateAbbreviation, locations]) => (
            <optgroup key={stateAbbreviation} label={stateAbbreviationTitles[stateAbbreviation]}>
              {locations.map((location) => (
                <option key={location.city} value={location.fullLocation}>
                  {location.city}
                </option>
              ))}
            </optgroup>
          ))}
      </Fragment>
    );
  };

  return <CommonSelect {...props} name={props.name || 'location'} options={[]} optionsCustom={getCustomOptions()} />;
};
